import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from '../crud.service';
import { Observable } from 'rxjs';
import { IndicatorData } from '../../models/indicator-data';
import { ExportSheet } from './export-helper.service';

@Injectable({
  providedIn: 'root',
})
export class IndicatorDataService extends CrudService<IndicatorData> {
  protected basePath = 'indicator-data'; // Specific for IndicatorDataService
  public instanceType = 'indicator-data'; // Used in base service for constructing URLs

  updatePublishStatus(
    ids: string[],
    isLocked: boolean
  ): Observable<IndicatorData> {
    if (isLocked) {
      return this.http.put<IndicatorData>(
        `${this.getBaseUrl()}/publishMany`,
        ids
      );
    } else {
      return this.http.put<IndicatorData>(`${this.getBaseUrl()}/lockMany`, ids);
    }
  }

  /**
   * overwrite updateMultiple - invoke persistMany instead for IndicatorDatas
   * @param items
   */
  override updateMultiple(items: IndicatorData[]): Observable<IndicatorData> {
    return this.http.post<IndicatorData>(
      `${this.getBaseUrl()}/persistMany`,
      items
    );
  }

  getImportUrl(multipleYears: boolean) {
    return `${this.getBaseUrl()}/convertXlsxToJson?mode=${multipleYears ? 'multipleYears' : 'singleYear'}`;
  }

  convertToXlsx(IndicatorData: ExportSheet[], filename: string) {
    return this.http.post(
      `${this.getBaseUrl()}/convertJsonToXlsx`,
      { data: IndicatorData, filename: filename },
      {
        responseType: 'blob',
      }
    );
  }

  convertChartDataToXlsx(
    data: ExportSheet[],
    filename: string,
    source: string
  ) {
    return this.http.post(
      `${this.getBaseUrl()}/convertArrayToXlsx`,
      { data, filename, source },
      {
        responseType: 'blob',
      }
    );
  }

  findMany(
    dataLayerIds: string[],
    categoryIds: string[],
    filterByKeys?: string[]
  ) {
    return this.http.post<{ [key: string]: IndicatorData }>(
      `${this.getBaseUrl()}/findMany`,
      { dataLayerIds, categoryIds, filterByKeys: filterByKeys ?? [] }
    );
  }

  findByIndicatorIds(indicatorIds: string[]) {
    return this.http.post<{ [key: string]: IndicatorData }>(
      `${this.getBaseUrl()}/findByIndicators`,
      { indicatorIds }
    );
  }

  constructor(http: HttpClient) {
    super(http);
  }
}
